import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import Axios from "axios";
import FormHelper from "@Scripts/Common/FormHelper";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "AccountExternalRegister" })
export default class AccountExternalRegister extends Vue {
    public localizer: any = Localizer;
    public formHelper: any = FormHelper;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public options: any = null;
    public formData: any = {};
    public validationErrors: any[] = [];
    public isPrivacyPolicyShow: boolean = false;
    public privacyPolicy: string = null;

    @Prop() readonly userName: string;
    @Prop() readonly email: string;
    @Prop() readonly returnUrl: string;

    get routes() {
        return (<any>window).App.routes;
    }

    public async created() {
        this.options = (await Axios.post(this.routes.Account_GetOptions, null, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

        this.formData.userName = this.userName ?? null;
        this.formData.email = this.email ?? null;
    }

    public async submitForm() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            let result = (await Axios.post(this.routes.AccountExternal_ExternalRegister, this.formData, { headers: { "RequestVerificationToken": FormHelper.getRequestVerificationToken() } })).data;

            this.isSuccess = true;

            window.location.href = result.redirectUrl ? result.redirectUrl : (this.returnUrl ? this.returnUrl : "/");
        } catch (error) {
            if (error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public isEmailInUse(): boolean {
        return (this.validationErrors.length !== 0 && this.validationErrors.filter(x => x.message === this.localizer.get("Account.Common.Email_InUse")).length > 0);
    }

    public async showPrivacyPolicy() {
        this.isPrivacyPolicyShow = !this.isPrivacyPolicyShow;

        if (!this.privacyPolicy) {
            let response = await Axios.post(this.routes.Terms_GetPrivacyPolicy);
            this.privacyPolicy = Object.freeze(response.data.description);
        }
    }
};